<template>
  <v-card>
    <v-toolbar
      color="#f87723"
      dark
    >{{ importDataTitle }}</v-toolbar>
    <v-card-text>
      <div class="pt-5">{{ importDataText }}</div>
      
      <div class="mt-4">
        <v-row>
          <v-col cols="12" sm="12">
            <v-combobox
              v-model="selectedTable"
              :label="$t('DB_TABLES.IMPORT_DATA.DB_LABEL')"
              :items="allDbTables"
              item-text="TABLE_NAME"
              item-value="TABLE_NAME"
              @change="setDatabaseCols"
            ></v-combobox>
          </v-col>
        </v-row>
        <div class="">If uploading a CSV file, and the header row is not 0, set it here:</div>
        <v-row>
          <v-col sm="1">
            <v-text-field v-model="headerRow" type="number" min="0" value="0"></v-text-field>
          </v-col>
        </v-row>
        <v-file-input v-model="uploadedFile" :label="$t('DB_TABLES.IMPORT_TABLE.LABEL')" @change="handleFileUpload" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"></v-file-input>
        <!-- <input type="file" @change="handleFileUpload" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" /> -->
        <h2 class="mt-2" v-if="loading">{{ loadingText }}</h2>
        <v-progress-linear indeterminate rounded height="10" v-if="loading">
          <!-- <strong>{{ uploadProgress }}%</strong> -->
        </v-progress-linear>
        
        <div class="mt-4" v-if="!loading && previewData.length > 0">
          <h2>Uploaded Data Preview</h2>
          <v-data-table
            :headers="tableHeaders"
            :items="previewData"
            :items-per-page="10"
            class="elevation-1 mx-3 mb-3"
            fixed-header
          >
            <template v-slot:item="{ item }">
              <tr>
                <td v-for="(value, key, index) in item" :key="index">{{ value }}</td>
              </tr>
            </template>
          </v-data-table>

          <h2>Map Columns</h2>
          <v-row v-for="(column, index) in tableHeaders" :key="index">
            <v-col cols="12" sm="6">
              <h3 class="mt-5">{{ column.text }}</h3>
            </v-col>
            <v-col cols="12" sm="6">
              <v-select
                v-model="columnMapping[column.text]"
                label="Select Column"
                :items="databaseColumns"
                dense
              ></v-select>
            </v-col>
          </v-row>

        </div>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-btn
        text
        @click="cancelImportData()"
      >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
      <v-spacer></v-spacer>
      <v-btn
        text
        @click="confirmImportData()"
      >{{ $t('GENERAL.BTNS.CONFIRM') }}</v-btn>
    </v-card-actions>

    <v-snackbar
      v-model="snack"
      :timeout="3000"
      :color="snackColor"
    >
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          v-bind="attrs"
          text
          @click="snack = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
import * as XLSX from 'xlsx';
import { mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters(['allDbTables', 'gulperUrl', 'gulperFileHeaders', 'gulperFilePreview', 'gulped'])
  },
  data() {
    return {
      loading: false,
      loadingText: 'Uploading data, please wait...',
      importDataTitle: this.$t('DB_TABLES.IMPORT_DATA.TITLE'),
      importDataText: this.$t('DB_TABLES.IMPORT_DATA.DESC'),
      selectedTable: '',
      targetTable: '',
      headerRow: 0,
      uploadedFile: null,
      uploadProgress: 0,
      uploadedData: [],
      previewData: [],
      columnMapping: {},
      databaseColumns: [],
      tableHeaders: [],
      totalRowCount: 0,
      rowCount: 0,
      uploadInterval: null,
      snack: false,
      snackColor: '',
      snackText: ''
    };
  },
  created() {
    this.unsubscribe = this.$store.subscribe((mutation) => {
      if(mutation.type === 'GULPER_URL') {
        this.$nextTick(() => {
          if(this.gulperFileHeaders.length > 0) {
            this.previewData = this.mapData(this.gulperFileHeaders, this.gulperFilePreview);
            this.loading = false;
          }
        });
      }

      if(mutation.type === 'GULPED') {
        this.$nextTick(() => {
          this.loading = false;
          this.importReset();
          this.$emit('closeImportData');
        });
      }
    });
    this.importReset();
  },
  beforeDestroy() {
    this.unsubscribe();
  },
  methods: {
    importReset() {
      this.loadingText = 'Uploading data, please wait...';
      this.selectedTable = '';
      this.targetTable = '';
      this.headerRow = 0;
      this.uploadedFile = null;
      this.uploadProgress = 0;
      this.$store.commit('GULPER_URL', '');
      this.$store.commit('GULPER_FILE_HEADERS', []);
      this.$store.commit('GULPER_FILE_PREVIEW', []);
      this.uploadedData = [];
      this.previewData = [];
      this.columnMapping = {};
      this.databaseColumns = [];
      this.tableHeaders = [];
      this.totalRowCount = 0;
      this.rowCount = 0;
      this.uploadInterval = null;
    },
    setDatabaseCols() {
      let cols = [];
      this.targetTable = this.selectedTable.TABLE_NAME;

      for(let i = 0; i < this.allDbTables.length; i++) {
        if(this.allDbTables[i].TABLE_NAME == this.targetTable) {
          let tableData = JSON.parse(this.allDbTables[i].TABLE_DATA);
          
          for(let j = 0; j < tableData.length; j++) {
            if(tableData[j].fieldName != 'ID') {
              cols.push(tableData[j].fieldName);
            }
          }
        }
      }
      this.databaseColumns = cols;
    },
    sanatise(item) {
      return item.replace(/(^"|"$)/g, '');
    },
    calculateUploadProgress(totalRowCount, rowCount) {
      // this.$nextTick(() => {
        
      // });
      // console.log('setting interval')
      // this.uploadInterval = setInterval(function() {
        this.uploadProgress = Math.round((rowCount / totalRowCount) * 100);
        // console.log(this.uploadProgress)
      // }, 1000);

    },
    stopUploadProcess() {
      console.log('clearing interval')
      clearInterval(this.uploadInterval);
    },
    handleFileUpload() {
      this.loading = true;
      
      const file = this.uploadedFile;
      if (!file) return;
      
      const reader = new FileReader();
      reader.onloadend = (e) => {
        // Strip out the base64 test at the start
        let index = e.target.result.indexOf('base64');
        index += 7;
        const data = e.target.result.slice(index);
        this.gulpFile(data, file);
      };
      reader.readAsDataURL(file);
    },
    gulpFile(data, file) {
      let payload = {
        'requestType': 'mapper',
        'headerRow': this.headerRow,
        'name': file.name,
        'mimeType': file.type,
        'fileData': data
      }
      this.$store.dispatch('uploadGulperData', payload);
    },
    // parseFileData(data, file) {
    //   let formattedData = [];
    //   if (file.name.endsWith('.csv')) {
    //     // Parse CSV file
    //     formattedData = this.parseCSV(data);
    //   } else if (file.name.endsWith('.xlsx')) {
    //     // Parse Excel file
    //     formattedData = this.parseExcel(data);
    //   }
    //   this.uploadedData = formattedData;
    //   this.previewData = formattedData.slice(0,10);
    // },
    // parseCSV(data) {
    //   const rows = data.split('\n').map(row => row.split(','));
    //   let headers = rows[this.headerRow];

    //   headers.forEach((header, index) => {
    //     headers[index] = this.sanatise(header);
    //   });
      
    //   this.tableHeaders = headers.map(header => ({ text: header, value: header }));

    //   const dataStart = this.headerRow + 1;
    //   let totalRowCount = rows.length - dataStart;
    //   console.log('Total rows:', totalRowCount)
    //   let rowCount = 1;
    //   this.initialiseColumnMapping(this.tableHeaders);
    //   // this.calculateUploadProgress();
    //   return rows.slice(dataStart).map(row => {
    //     if(rowCount == totalRowCount) {
    //       this.loading = false;
    //       // this.stopUploadProcess();
    //     }
    //     rowCount++;
    //     this.calculateUploadProgress(totalRowCount, rowCount);
    //     return headers.reduce((obj, header, index) => {
    //       obj[header] = row[index];
    //       return obj;
    //     }, {});
    //   });
    // },
    // parseExcel(data) {
    //   const workbook = XLSX.read(data, { type: 'binary' });
    //   const sheetName = workbook.SheetNames[0];
    //   const sheet = workbook.Sheets[sheetName];
    //   return XLSX.utils.sheet_to_json(sheet, { header: 1 });
    // },
    // mapHeaders(headers) {
    //   this.tableHeaders = headers.map(header => ({ text: header, value: header }));
    //   this.mapColumns(headers);
    // },
    mapData(headers, data) {
      headers.forEach((header, index) => {
        headers[index] = this.sanatise(header);
      });

      this.tableHeaders = headers.map(header => ({ text: header, value: header }));
      this.mapColumns(headers);
      
      return data.map(row => {
        return headers.reduce((obj, header, index) => {
          obj[header] = row[index];
          return obj;
        }, {});
      });
    },
    mapColumns(columns) {
      // Initialize column mapping with default values
      columns.forEach(column => {
        this.$set(this.columnMapping, column, '');
      });      
    },
    cancelImportData() {
      this.importReset();
      this.$emit('closeImportData');
    },
    confirmImportData() {
      this.loadingText = 'Importing data, please wait...';
      this.loading = true;

      // Put mapped columns into array
      let colArr = [];
      for (let [key, value] of Object.entries(this.columnMapping)) {
        if(value) {
          colArr.push({ col: value });
        }
      }

      let payload = {
        'requestType': 'import',
        'headerRow': this.headerRow,
        'targetTable': this.targetTable,
        'url': this.gulperUrl,
        'columns': JSON.stringify(colArr)
      }
      this.$store.dispatch('importGulperData', payload);
    }
  }
};
</script>